<template>
    <div class="footer">
        <p class="footer--title">{{$t('FOOTER_GOT_A_QUESTION')}}</p>
        <!-- Telephone -->
            <div class="footer--telephone">
                <div class="footer--telephone--icon">
                    <img src="@/assets/images/decoration/telephone-icon.png" alt="Call">
                </div>
                <div class="footer--telephone--text">
                    <p>
                        <a class="link footer--telephone--text" href="tel:+442083966696">0208 396 6696</a>
                    </p>
                </div>
            </div>

            <!-- Email -->
            <div class="footer--email">
                <div class="footer--email--icon">
                    <img src="@/assets/images/decoration/email-icon.png" alt="Email">
                </div>
                <div class="footer--email--text">
                    <email-us :customStyles="{ 'font-size': '15px'}"></email-us>
                </div>
            </div>
    </div>
</template>

<script>
import emailUs from '@/components/structure/navigation/navigation/EmailUs';

export default {
    name: 'SimpltFooter',
    components: {
        emailUs,
    },
};
</script>

<style lang="scss" scoped>
.footer {
    margin: 20px;
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &--title {
        font-weight: 400;
        font-size: 15px;
        line-height: 20px;
    }
    &--telephone, &--email {
        display: flex;
        align-items: center;
        justify-content: center;
        &--icon {
            width: 24px;
            height: 24px;
            margin-right: 10px;
        }
        &--text {
            font-size: 15px;
            line-height: 20px;
            margin: 0;
        }
    }
}
</style>
